import script from "./TransferChildSeats.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferChildSeats.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QField,QIcon,QList,QItem,QItemSection,QItemLabel,QBtn});qInstall(script, 'directives', {ClosePopup});
